<template>
  <div class="overflow-hidden">
    <section class="cp-page py-4">
      <header-help :is-loading="isLoading"></header-help>
      
      <!-- Background animated orbs using Stella brand colors -->
      <div class="cp-bg-orb cp-bg-orb--1"></div>
      <div class="cp-bg-orb cp-bg-orb--2"></div>

      <div class="container position-relative my-auto" style="z-index: 1;">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5">
            <div class="cp-content-card p-4 p-md-5">
              
              <div class="text-center mb-4">
                <div class="d-inline-flex align-items-center justify-content-center mb-2" 
                     style="width: 56px; height: 56px; border-radius: 50%; background: rgba(229,59,185,0.15); color: #E53BB9; font-size: 22px;">
                  <i class="fa fa-user-circle"></i>
                </div>
                <h3 class="text-white font-weight-700 mb-1">Set Up Your Profile</h3>
                <p class="text-white-50 font-size-14 mb-0">
                  Manage your subscription and messages with {{ getInvitee.name }}
                </p>
              </div>

              <global-message></global-message>

              <div class="form-group mb-3">
                <label class="text-white font-size-13 mb-2 font-weight-500">Your Full Name</label>
                <required-field v-if="isRequired('name')"/>
                <input type="text" placeholder="Enter your full name"
                  class="form-control cp-input"
                  v-model="user.name">
              </div>

              <div class="form-group mb-3">
                <label class="text-white font-size-13 mb-2 font-weight-500">Account Password</label>
                <required-field v-if="isRequired('password')"/>
                <div class="position-relative">
                  <input placeholder="Create a password"
                    type="password" class="form-control cp-input"
                    id="password" v-model="user.password" style="padding-right: 42px;">
                  <span class="position-absolute cursor-pointer text-muted font-size-16" 
                        style="right: 14px; top: 12px;"
                        @click="showPassword('password')">
                    <i id="show_id" class="fa fa-eye text-white-50"></i>
                    <i id="hide_id" class="fa fa-eye-slash text-white-50 d-none"></i>
                  </span>
                </div>
              </div>

              <div class="form-group mb-3">
                <label class="text-white font-size-13 mb-2 font-weight-500">Country</label>
                <required-field v-if="isRequired('countryCode')"/>
                <searchable-country-select 
                  v-model="user.countryCode" 
                  :countries="countries" 
                  placeholder="Select Country" />
              </div>

              <div class="form-group mb-4">
                <label class="text-white font-size-13 mb-2 font-weight-500">Phone Number</label>
                <required-field v-if="isRequired('phone')"/>
                <country-phone-input
                  v-model="user.phone"
                  :country-code="user.countryCode"
                  :is-submit="isSubmit"
                />
              </div>

              <button type="submit" 
                      class="cp-btn-primary w-100"
                      @click="finish()">
                Complete Profile <i class="fa fa-check ms-2"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import GlobalMessage from "@/components/module/shared/GlobalMessage";
import LoadingModal from "@/components/module/shared/LoadingModal";
import {mapActions} from "vuex";
import {showPassword} from "@/common/Utils";
import {required} from "vuelidate/lib/validators";
import {SERVICE_IDENTIY} from "@/properties/micro-service";
import HeaderHelp from "@/components/module/influencer/shared/HeaderHelp";
import {customerAccountMixin} from "@/mixin/customer-account/customer-account-mixin";
import RequiredField from "@/components/module/shared/RequiredField";
import SearchableCountrySelect from "@/components/module/shared/SearchableCountrySelect";
import CountryPhoneInput from "@/components/module/shared/CountryPhoneInput";
import {isPhoneValidForCountry} from "@/common/phone-validation";
import titleMixin from "../../../../mixin/title-mixin";

export default {
  name: "CreateAccountComplete",
  title: 'Create account complete',
  mixins: [customerAccountMixin, titleMixin],
  components: {
    GlobalMessage, LoadingModal, HeaderHelp, RequiredField, SearchableCountrySelect, CountryPhoneInput
  },
  data() {
    return {
      user: {},
      isSubmit: false,
      countries: []
    }
  },
  validations() {
    return {
      user: {
        name: {required},
        countryCode: {required},
        password: {required},
        phone: {
          required,
          validPhone: (val) => isPhoneValidForCountry(val, this.user ? this.user.countryCode : 'US')
        },
      }
    };
  },
  created() {
    this.user = this.getUser;
    this.user.countryCode = 'US';
    this.loadCountries();
  },
  methods: {
    ...mapActions(['setMessage', 'setUser']),
    showPassword,
    isRequired(attrib) {
      if (!this.isSubmit || !this.$v.user || !this.$v.user[attrib]) return false;
      const field = this.$v.user[attrib];
      if (field.required !== undefined && !field.required) return true;
      if (field.validPhone !== undefined && !field.validPhone) return true;
      return false;
    },
    isValidEmail() {
      return this.isSubmit && !this.$v.user.email.email;
    },
    loadCountries() {
      this.getUnSecureData('identity/api/v1/lookup/countries', (data) => {
        this.countries = data;
      });
    },
    finish() {
      this.isSubmit = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.patchData(`${SERVICE_IDENTIY}/api/v1/customers/${this.user.id}`, this.user, (data) => {
        this.$store.dispatch('setMessage', 'Account updated successfully.');
        this.user = data;
        this.setUser(data);
        this.$router.replace({name: 'MessageCta', query: {saved: true}})
      });
    },
  }
}
</script>
